// PDF round 3 N4: which deployment this bundle was built for.
//
// Set at build time via VITE_DEPLOY_ENV (see Dockerfile + .github/workflows/
// build-panel.yml). Used to gate environment pickers — e.g. the Add Bank Rail
// modal only offers Sandbox in staging builds and Production in prod builds.
// On a local dev `vite` run the flag is unset and we fall back to "development"
// where both options are exposed.

export type DeployEnv = "production" | "staging" | "development";

const raw = (import.meta.env.VITE_DEPLOY_ENV ?? "").toString().toLowerCase();

export const deployEnv: DeployEnv =
  raw === "production" || raw === "staging" || raw === "development"
    ? (raw as DeployEnv)
    : "development";

// Which bank-rail environment a freshly-added rail should default to.
// In dev both are allowed (operator picks); in staging we lock to sandbox,
// in prod we lock to production.
export function defaultRailEnvironment(): "sandbox" | "production" {
  return deployEnv === "production" ? "production" : "sandbox";
}

// Whether the operator can choose between sandbox + production for this build.
// `false` means the UI hides the picker and the value is forced to whatever
// matches the deploy.
export function canPickRailEnvironment(): boolean {
  return deployEnv === "development";
}

// Human label for the locked environment, shown next to the hidden picker.
export function lockedRailEnvironmentLabel(): string {
  return defaultRailEnvironment() === "production" ? "Production" : "Sandbox";
}
